import * as actions from './actions'

const sellersModule = {
  namespaced: true,
  actions,
}

export default sellersModule
